<template>
  <svg viewBox="0 0 1920 1080"></svg>
</template>

<script>
export default {
  name: 'ImagePlaceholder',
}
</script>
